import { AdditionalOptionsListbox } from "./AdditionalOptionsListBox";
import type { AsyncApiParams, CollectorConfig } from "providers/HostedScrapingProvider/types";
import { getSdeOutputFormats, sdeOutputFormatLabels } from "sdecontent";

type OutputFormatDropdownProps = {
  collectorConfig: CollectorConfig;
  updateApiParams: (key: string) => (newValue: string | boolean | number | undefined, apiParamsToChange?: AsyncApiParams) => AsyncApiParams;
};
const OutputFormatDropdown = ({ collectorConfig, updateApiParams}: OutputFormatDropdownProps) => {

  const supportedFormats = getSdeOutputFormats(collectorConfig.type);
  const options = supportedFormats.map(format => ({ text: sdeOutputFormatLabels[format] ?? format, value: format }));

  const value = supportedFormats.includes(collectorConfig.apiParams?.outputFormat as string)
    ? collectorConfig.apiParams?.outputFormat
    : 'json';

  return <>
    <div className="mt-5">
      Output format
    </div>
    <AdditionalOptionsListbox value={ value } options={ options }
      callback={(new_value) => updateApiParams('outputFormat')(new_value === 'json' ? undefined : new_value)}
      buttonTestId="testApiPlaygroundOutputFormat" />
  </>
};
export default OutputFormatDropdown;

